/* src/app/module/service-advisors/service-advisor-details/service-advisor-details.component.scss */
.with-sidebar {
  margin-left: 250px;
  background-color: #FCFCFD;
}
.no-sidebar {
  background-color: #FCFCFD;
  overflow-y: auto;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  height: 30px;
  width: 90px;
}
.tag.submitted {
  background-color: #FFF1E0;
  color: #D47500;
  justify-content: space-around;
}
.tag.submitted::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #D47500;
}
.tag.approved {
  background-color: #ECFDF3;
  color: #027A48;
  justify-content: space-around;
  width: 80px;
}
.tag.approved::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 0px;
  border-radius: 50%;
  background-color: #4caf50;
}
.tag.inreview {
  background-color: #f4f4f4;
  color: #757575;
  justify-content: space-around;
}
.tag.inreview::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #757575;
}
.tag.rejected {
  background-color: #FFEAEB;
  color: #FF474D;
  justify-content: space-around;
}
.tag.rejected::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #FF474D;
}
.top-container {
  display: flex;
  flex-direction: column;
  padding: 18px 0px 12px 0px;
  border-radius: 0 0 24px 24px;
  background: #f2f4f7;
}
.card-top {
  border-radius: 10px;
  background: white;
  margin: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.link-button {
  background: none;
  border: none;
  color: black;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;
}
.link-button:focus {
  outline: none;
}
.more-button-container {
  display: flex;
  justify-content: flex-end;
  margin: 12px;
}
.card-content {
  display: flex;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffecd9;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #ff8c00;
  margin-right: 15px;
}
.info {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}
.name-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}
.name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.section {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}
.details {
  display: flex;
}
.detail {
  flex: 1;
}
.detail-title {
  font-size: 14px;
  color: #344054;
  margin-bottom: 5px;
  font-weight: bolder;
}
.detail-content {
  font-size: 14px;
  color: #374151;
  width: 175px;
}
.tab-container {
  margin: 20px 12px;
  background: white;
  border-radius: 10px;
}
.tabs {
  display: flex;
  border-bottom: 2px solid #f2f4f7;
}
.tab-button {
  flex: 1;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #333;
  transition: background-color 0.3s;
}
.tab-button.active {
  background-color: #f2f4f7;
  color: #ff8c00;
}
.tab-content {
  padding-top: 30px;
  padding-left: 70px;
}
.document-list {
  display: flex;
  flex-direction: column;
}
.document-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f2f4f7;
}
.document-icon {
  margin-right: 10px;
}
.document-info {
  flex-grow: 1;
}
.document-name {
  font-size: 14px;
  font-weight: 600;
  color: #344054;
}
.document-size {
  font-size: 12px;
  color: #666;
}
.document-remove {
  background: none;
  border: none;
  cursor: pointer;
}
.btn-1 {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  height: 40px;
  border: 1px solid #D0D5DD;
  transition:
    background-color 0.3s,
    color 0.3s,
    border-color 0.3s;
  background-color: #fff;
}
.btn-2 {
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  padding: 10px 16px;
  border: 1px solid #D0D5DD;
  cursor: pointer;
  background-color: #fff;
  height: 40px;
}
.btn-1:hover,
.btn-2:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.btn-warning-1 {
  background-color: white;
  color: #b42318;
  border: 1px solid #b42318;
}
.btn-warning-edit {
  background-color: white;
  color: #b42318;
  border: 1px solid #b42318;
}
.top-content {
  gap: 16px;
}
.outlined-1 {
  background-color: #fff;
  color: #b42318;
  border-color: #b42318;
}
.outlined-2 {
  background-color: #fff;
  color: #000;
  border-color: #D0D5DD;
}
::ng-deep .p-dialog-mask {
  background-color: rgba(8, 12, 20, 0.7);
  backdrop-filter: blur(8px);
}
.bio {
  color: var(--Text-Light-3, #9AA2B2);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}
.bio-details {
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 30px;
  margin-top: 16px;
  width: 690px;
}
.document-tabs .tab-header {
  display: flex;
  border-bottom: 1px solid #e4e7ec;
  margin-bottom: 10px;
  padding-top: 20px;
}
.document-tabs .tab-item {
  padding: 14px 28px;
  cursor: pointer;
  font-weight: bold;
  color: #475467;
  border-bottom: 2px solid transparent;
  transition: color 0.3s, border-bottom 0.3s;
}
.document-tabs .tab-item.active {
  color: #ff8c00;
  border-bottom: 2px solid #ff8c00;
}
i.circle {
  display: inline-block;
  border-radius: 60px;
  background-color: #FFE8CC;
  padding: 0.4em 0.4em;
}
.circle1 {
  display: inline-block;
  border-radius: 60px;
  background-color: #FFF1E0;
  padding: 0.5em 0.5em;
}
i.hover {
  background-color: #FF9F2A;
  display: inline-block;
  border-radius: 60px;
  padding: 0.5em 0.6em;
  cursor: pointer;
  box-shadow: 7px 6px 28px 1px rgba(0, 0, 0, 0.24);
}
.file:hover {
  text-decoration: underline;
}
.pdf-container {
  position: relative;
  text-align: center;
}
.pdf-controls {
  margin-top: 10px;
}
.download-button-container button i {
  margin-right: 5px;
}
.styled-button {
  background: none;
  border: 1px solid #FF8C00;
  color: #FF8C00;
  padding: 12px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  align-items: center;
}
.styled-button i {
  margin-right: 5px;
}
.styled-button:hover {
  background-color: #FF8C00;
  color: #fff;
}
.styled-button:disabled {
  background: #f2f2f2;
  color: #b3b3b3;
  border: 1px solid #d9d9d9;
  cursor: not-allowed;
}
::ng-deep .p-dialog .ui-dialog-content {
  padding: 0;
}
::ng-deep .p-dialog ngx-extended-pdf-viewer {
  width: 100%;
  height: 100%;
}
::ng-deep .p-dialog img {
  display: block;
  max-width: 100%;
  max-height: 70vh;
  margin: 0 auto;
}
.scroll-container {
  display: flex;
  overflow-x: auto;
  padding: 16px;
  gap: 16px;
}
.scroll-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  min-width: 200px;
  flex: 0 0 auto;
  transition: transform 0.3s ease;
}
.scroll-card:hover {
  transform: translateY(-4px);
}
.scroll-card h4 {
  margin: 0 0 8px;
}
.scroll-card .document-actions {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
}
.document-content {
  margin-top: 10px;
  padding: 5px;
}
.document-actions {
  margin-top: 5px;
  display: flex;
  justify-content: flex-start;
}
.document-list-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.document-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 90%;
}
.document-list-item {
  margin-bottom: 25px;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease,
    background-color 0.3s ease;
  background-color: #fff;
  padding: 15px;
  border-radius: 16px;
}
.document-list-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  background-color: #F2F4F7;
}
.document-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.document-header {
  flex-grow: 1;
  margin-right: 20px;
}
.document-header h4 {
  font-weight: bold;
  color: #344054;
  font-size: 14px;
  margin: 0;
}
.document-header p {
  font-size: 14px;
  color: #475467;
  margin: 0;
}
.document-info-container {
  display: flex;
  align-items: center;
  border: 1px solid #FF9F2A;
  border-radius: 8px;
  padding: 12px 24px;
  background-color: #fff;
  width: 700px;
}
.document-icon {
  color: #FF9F2A;
  margin-right: 40px;
}
.document-details {
  flex-grow: 1;
  margin-right: 10px;
}
.document-name {
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.document-size {
  font-size: 14px;
  color: #475467;
}
.document-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.p-button-text.p-button-sm.p-button-rounded {
  border: none;
  color: #FF9F2A;
}
.p-button-secondary.p-button-sm {
  color: #FF9F2A;
}
.p-button-rounded .pi {
  font-size: 1rem;
}
.btn-1:focus,
.btn-2:focus {
  outline: none !important;
  box-shadow: none !important;
}
.review-heading {
  font-size: 20px;
  color: #000;
  font-weight: 600;
}
::ng-deep .p-timeline .p-timeline-event-marker {
  border: 2px solid orange;
  background:
    linear-gradient(
      135deg,
      #FFD700,
      #FFA500);
}
.p-text-secondary strong {
  color: #000;
  font-size: 15px;
  margin-bottom: 10px;
}
/*# sourceMappingURL=service-advisor-details.component-Z2PHRK57.css.map */
